<template>
  <div class="accordion-item" :class="{ 'is-active': acordionIsOpen }">
    <h3>
      <button class="opener" @click="toggleAcordion">
        <span class="accordion-title">{{ header }}</span>
        <span
          class="icon icon-transparent-fill"
          :class="{ active: acordionIsOpen }"
          v-icon:head-arrow
        ></span>
      </button>
    </h3>
    <div class="slide">
      <div class="content pb-5">
        <div class="accordion-snippet" :class="{hasContent}">
          <slot name="default" />
        </div>
        <div v-if="hasContent" class="accordion__content" :class="{open}">
          <div class="accordion__content--wrapper">
            <div class="mt-4">
              <slot name="content"></slot>
            </div>
          </div>
          <button class="sticky-toggle accordion-button" ref="button" @click="onToggle">
            {{open ? 'Show less' : 'Show more'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AcordionItem",
  props: {
    header: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      acordionIsOpen: true,
      open: false,
    };
  },
  computed:{
    hasContent(){
      return this.$slots['content'] && this.$slots['content'].length
    }
  },
  mounted() {
    this.acordionIsOpen = this.expanded ?? false;
  },
  watch: {
    acordionIsOpen(v){
      if(!v)
        this.open = false
    }
  },
  methods: {
    onToggle(){
      this.open = !this.open;
    },
    toggleAcordion(e) {
      e.preventDefault();
      this.acordionIsOpen = !this.acordionIsOpen;

    },
  },
};
</script>
